<template>
    <v-col cols="12" md="2" ma-1>
        <v-card>
            <v-card-title class="title font-weight-black">
                <v-icon class="pr-3">description</v-icon> Property Details 
            </v-card-title>

            <v-card-text>
                <v-container fluid>
                    <v-row>
                        <v-col>
                            <v-btn class="mt-1" 
                                   block 
                                   :disabled="!hotel.bookable_via_iescape && !hotel.bookable_via_partner && !hotel.bookable_via_direct" 
                                   :href="mainContactsUrl">Main Contacts</v-btn>
							<v-btn class="mt-1" 
                                   block 
                                   :disabled="!hotel.bookable_via_iescape && !hotel.bookable_via_partner && !hotel.bookable_via_direct" 
                                   :href="reservationContactsUrl">Reservation Contacts</v-btn>
							<v-btn class="mt-1" 
                                   block 
                                   :disabled="!hotel.bookable_via_iescape && !hotel.bookable_via_partner && !hotel.bookable_via_direct" 
                                   :href="telephonesUrl">Telephones</v-btn>
                            <v-btn class="mt-1" 
                                   block 
                                   :href="alternativeNamesUrl">Alternative Names</v-btn>
                            <v-btn class="mt-1" 
                                   block 
                                   :href="hotelUrlsUrl">Supported URLs</v-btn>
                            <v-btn class="mt-1" 
                                   block 
                                   :href="backgroundInfoUrl">Background Info</v-btn>
                            <v-btn class="mt-1" 
                                   block 
                                   :href="hotelLocationUrl">Location</v-btn>
                            <v-btn class="mt-1" 
                                   block 
                                   :disabled="!hotel.bookable_via_iescape && !hotel.bookable_via_partner && !hotel.bookable_via_direct" 
                                   :href="hotelUpdatesUrl">Updates</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

        </v-card>
    </v-col>
</template>

<script>
    /**
     * Display buttons linking through to a hotels' pages
     */
    export default {
        props:['results'],

        data: function() {
            return {
				mainContactsUrl: '',
				reservationContactsUrl: '',
				telephonesUrl: '',
                hotelUrlsUrl: '',
				backgroundInfoUrl: '',
                alternativeNamesUrl: '',
				hotelLocationUrl: '',
                hotel: null
            }
        },

        /**
         * Perform the following actions on startup
         */
        mounted: function(){
            // Extract the hotel ID from the result set passed into this panel from the dashboard
            var hotelKey = this.results.data[0].hotel_key;
			this.mainContactsUrl = "/hotels/" + hotelKey + "/main-contacts";
			this.reservationContactsUrl = "/hotels/" + hotelKey + "/reservation-contacts/list";
			this.telephonesUrl = "/hotels/" + hotelKey + "/telephones/list";
            this.alternativeNamesUrl = "/hotels/" + hotelKey + "/alternative-names/list";
            this.hotelUrlsUrl = "/hotels/" + hotelKey + "/urls/list";
			this.backgroundInfoUrl = "/hotels/" + hotelKey + "/background-info";
			this.hotelLocationUrl = "/hotels/" + hotelKey + "/location";
            this.hotelUpdatesUrl = "/hotels/" + hotelKey + "/hotel-updates";

            this.loadHotel();
        },

        methods: {

            loadHotel: function(){
                try {
                    // Extract the hotel ID from the result set passed into this panel from the dashboard
                    var hotelKey = this.results.data[0].hotel_key;

                    axios.get('/api/hotel/' + hotelKey + '/summary-information')
                        .then(function(response){
                            this.hotel = response.data.hotel;
                            this.loading = false;
                        }.bind(this));
                    }
                catch(exception){
                    console.log(exception);
                    this.hasProblem = true;
                }
            },

        }
    }
</script>



